import React, { useState } from 'react'

import { Box, Typography } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'

import { getPrice } from 'common/utils/conciergeDigitalInvoiceItem'
import { MAX_AMOUNT_OF_PICS, MIN_AMOUNT_OF_PICS } from 'common/utils/conciergeDigitalInvoiceItem.constants'
import ProductDescriptionItem from 'artkive/components/PageSections/ProductDescriptionItem'
import { TrackButton, withClickTracker } from 'artkive/components/Tracker'
import { DIGITAL_STORAGE, GET_BOX_CLICK } from 'artkive/constants/tracker/mainNavigation'
import useSale from 'artkive/hooks/useSale'
import { digitalBullets } from 'artkive/pages/Digital'

import DigitalStorageImg from 'images/ecom/pricing/DigitalStorage.png'
import DigitalStorageMobileImg from 'images/ecom/pricing/DigitalStorage-mobile.png'
import DigitalStorageMobileImgX2 from 'images/ecom/pricing/DigitalStorage-mobile-x2.png'
import DigitalStorageImgX2 from 'images/ecom/pricing/DigitalStorage-x2.png'

import ImageTextSection, { Picture } from '../ImageTextSection'
import { boxProductDisclaimers } from '../Pricing.constants'
import { CaptionBox } from '../Pricing.style'

import {
  BulletsBox,
  ButtonBox,
  CostHint,
  CustomSlider,
  ImageBox,
  Price,
  Separator,
  SliderBox,
  Title,
} from './DigitalStorageSection.style'

const TrackSlider = withClickTracker(CustomSlider, 'onChangeCommitted')

const DigitalStorageSection = () => {
  const muiTheme = useTheme()
  const [sliderValue, setSliderValue] = useState(MIN_AMOUNT_OF_PICS)

  const handleSliderChange = (e, value) => setSliderValue(value)
  const { boxCheckoutUrl } = useSale()

  return (
    <ImageTextSection
      reverse
      bgColor='#FFF0CC'
      imageContent={
        <ImageBox>
          <Picture>
            <source srcSet={`${DigitalStorageImgX2}`} media={muiTheme.breakpoints.up('lg').replace('@media ', '')} />
            <source
              srcSet={`${DigitalStorageImg}, ${DigitalStorageImgX2} 2x`}
              media={muiTheme.breakpoints.up('md').replace('@media ', '')}
            />
            <img
              srcSet={`${DigitalStorageMobileImg}, ${DigitalStorageMobileImgX2} 2x`}
              src={DigitalStorageMobileImg}
              alt='Account application preview'
            />
          </Picture>
        </ImageBox>
      }
      descriptionContent={
        <div>
          <Title variant='h2'>Art Digitization</Title>
          <BulletsBox>
            {digitalBullets.map(({ text }, index) => (
              <ProductDescriptionItem key={index}>{text}</ProductDescriptionItem>
            ))}
          </BulletsBox>
          <CostHint elevation={0}>
            <Typography component='span'>{sliderValue} Pieces</Typography>
            <Separator component='span'>—</Separator>
            <Price variant='h6'>{getPrice(sliderValue)}</Price>
          </CostHint>
          <SliderBox>
            <TrackSlider
              value={sliderValue}
              step={1}
              min={MIN_AMOUNT_OF_PICS}
              max={MAX_AMOUNT_OF_PICS}
              trackerEvent={DIGITAL_STORAGE.SLIDER_INTERACTION}
              onChange={handleSliderChange}
            />
          </SliderBox>
          <CaptionBox>
            <Typography variant='caption' component={Box} mb={2}>
              {boxProductDisclaimers[0]}
            </Typography>
            <Typography variant='caption' component={Box}>
              {boxProductDisclaimers[1]}
            </Typography>
          </CaptionBox>
          <ButtonBox>
            <TrackButton
              color='primary'
              href={boxCheckoutUrl}
              size='large'
              variant='contained'
              trackerEvent={GET_BOX_CLICK}
              trackerOptions={{
                section: 'get_digital_section',
              }}
            >
              Get My Box
            </TrackButton>
          </ButtonBox>
        </div>
      }
    />
  )
}

export default DigitalStorageSection
